/** `/c/$companyId/purchases/bills/$billId?tab` — a bill, from draft to posted. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DOC_PAGE_TABS } from "../api/codes";
import { SupplierDocPage } from "../bills/page/SupplierDocPage";

const search = z.object({
  tab: z.enum(DOC_PAGE_TABS).optional().catch(undefined),
  action: z.enum(["write-off"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/bills/$billId")({
  validateSearch: (raw) => search.parse(raw),
  component: BillRoute,
});

function BillRoute(): JSX.Element {
  const { companyId, billId } = Route.useParams();
  const { tab, action } = Route.useSearch();
  return (
    <SupplierDocPage companyId={companyId} kind="bills" docId={billId} tab={tab} action={action} />
  );
}
